// Import the functions you need from the SDKs you need

import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional

const firebaseConfig = {
    apiKey: "AIzaSyBiV0Bms_-dbSOlT7jGSViB_ENuTH684wE",
    authDomain: "artclvb-app.firebaseapp.com",
    projectId: "artclvb-app",
    storageBucket: "artclvb-app.appspot.com",
    messagingSenderId: "906352158634",
    appId: "1:906352158634:web:1cb7a798b10abf156a2dd3",
    measurementId: "G-SXYV6FRK0L"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Initialize services
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

export default app;